import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createEmployeeSalary = (formValues) => async (dispatch) => {
  formValues["data"] = "";
  try {
    const response = await backend.post(
      "api/hrm/salary/",
      { ...formValues },
      getConfig()
    );
    if (response.status === 201) {
      dispatch({
        type: types.CREATE_EMPLOYEE_SALARY,
        payload: { ...response.data },
      });
      message.success("Updated Successfully");
      // history.push("/salary");
    }
  } catch (error) {
    alert(error);
  }
};

export const getAllEmployeeSalary = () => async (dispatch) => {
  try {
    const response = await backend.get("api/hrm/salary/", getConfig());
    if (response.status === 200) {
      dispatch({
        type: types.GET_ALL_EMPLOYEE_SALARY,
        payload: response.data,
      });
      return response.data
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAllEmployeeSalaryP = (employee__branch = "", employee__Designation = "", employee__Department = "", Keyword = "", page = 1, page_size = 10) => async (dispatch) => {
  try {
    const response = await backend.get(`api/hrm/salaryP/?employee__Office=${employee__branch}&employee__Designation=${employee__Designation}&employee__Department=${employee__Department}&keyward=${Keyword}&page=${page}&page_size=${page_size}`, getConfig());
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificUserEmployeeSalary = (id) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/hrm/salary/?employee__id=${id}`,
      getConfig()
    );
    if (response.status === 200) {
      dispatch({
        type: types.GET_SPECIFIC_EMPLOYEE_SALARY,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteEmployeeSalary = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(`api/hrm/salary/${id}/`, getConfig());
    if (response.status === 204) {
      dispatch({ type: types.DELETE_EMPLOYEE_SALARY, payload: id });
    }
    // history.push("/salary");
  } catch (error) {
    alert(error);
  }
};

export const updateEmployeeSalary = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/hrm/salary/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      dispatch({
        type: types.UPDATE_EMPLOYEE_SALARY,
        payload: { ...response.data },
      });
      message.success("Updated Successfully");
    }

    // history.push("/salary");
  } catch (error) {
    alert(error.response);
  }
};

// Import Excel For new Employee Salary
export const importSalaryExcel = (file) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await backend.post("api/hrm/newexcelimportsalary/import_excel/", formData, {
      ...getConfig(),
      headers: {
        ...getConfig().headers,
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

//  BULK SALARY PROMOTION ACTIONS  //
// New action for bulk salary promotion import
export const importBulkPromotionExcel = (file, promotionData) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("increment_type", promotionData.increment_type);
    formData.append("increamentAmount", promotionData.increamentAmount);
    formData.append("increamentMonth", promotionData.increamentMonth);

    const response = await backend.post(
      "api/hrm/bulk-salary-promotions/import_excel/",
      formData,
      {
        ...getConfig(),
        headers: {
          ...getConfig().headers,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Action for bulk salary promotion by amount from Excel
export const importBulkPromotionByAmountExcel = (file, promotionData) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("increment_type", promotionData.increment_type);
    formData.append("increamentMonth", promotionData.increamentMonth);

    const response = await backend.post(
      "api/hrm/bulk-salary-promotions/import_excel_by_amount/",
      formData,
      {
        ...getConfig(),
        headers: {
          ...getConfig().headers,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Action to fetch promotion history
export const fetchPromotionHistory = (filters = {}) => async (dispatch) => {
  try {
    const params = new URLSearchParams();

    if (filters.employee) params.append('employee', filters.employee);
    if (filters.increment_type) params.append('increment_type', filters.increment_type);
    if (filters.month) params.append('month', filters.month);
    if (filters.is_increment !== undefined) params.append('is_increment', filters.is_increment);

    const response = await backend.get(
      `api/hrm/salary-promotions/?${params.toString()}`,
      getConfig()
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};